<template>
  <div v-show="active">
    <div class="hl_search_form" v-show="!$store.getters.modal.search">
      <button></button>
      <input type="text" class="hide-placeholder" v-model="input" :placeholder="text('search_placeholder')"
             :ref="'search-input'" @focus="onFocus()">
      <div class="hl_search_clear" @click="clear()"></div>
    </div>
  </div>

</template>

<script>
  import {CLEAR_SEARCH, SET_MODAL, SET_SEARCH_GOT_FIRST, SET_SEARCH_QUERY} from '@/store/mutations.type'
  import {FETCH_SEARCH} from '@/store/actions.type'
  import CategoryList from '@/components/ECommerce/Categories/CategoryList'
  import ProductList from '@/components/ECommerce/Products/ProductList'

  const MODE_CATEGORY = 0
  const MODE_POPULAR = 1
  const MODE_SEARCH = 2

  let debounce = require('lodash.debounce')

  export default {
    name: 'Search',
    components: {ProductList, CategoryList},
    props: {
      active: Boolean
    },
    data() {
      return {
        localActive: this.active,
        input: '',

        MODE_CATEGORY, MODE_POPULAR, MODE_SEARCH
      }
    },
    computed: {
      loadedCategories() {
        let ids = []
        for (let i in this.$store.getters.categories) {
          if (this.$store.getters.categories[i].id) {
            ids.push(this.$store.getters.categories[i].id)
          }
        }
        return ids
      }
    },
    watch: {
      active(active) {
        if (active) {
          this.enable()
        }
      },
      input: async function () {
        await this.$store.commit(CLEAR_SEARCH)
        await this.$store.commit(SET_SEARCH_QUERY, this.input)

        debounce(async () => {
          await this.search()
        }, 500)()
      }
    },
    methods: {

      updateActive(active) {
        this.$emit('update:active', active)
      },

      onFocus() {
        if (this.input && !this.$store.getters.modal.search) {
          this.$store.commit(SET_MODAL, {modal: 'search', status: true})
        }
      },

      clear() {
        if (!this.input.length) {
          this.updateActive(false)
        }
        this.input = ''
        this.$store.commit(SET_MODAL, {modal: 'search', status: false})
      },

      enable() {
        let input = this.$refs['search-input']
        if (document.activeElement !== input) {
          document.activeElement.blur()
        }
        setTimeout(function () {
          input.focus()
        }, 0)
      },

      async search() {
        this.items = []

        if (!this.input.length) {
          await this.$store.commit(CLEAR_SEARCH)
          this.$store.commit(SET_MODAL, {modal: 'search', status: false})
          return
        }

        await this.$store.dispatch(FETCH_SEARCH, {
          categories: this.loadedCategories,
          query: this.input
        })
      }

    }
  }
</script>

<style scoped>

  div.placeholder {
    width: 100%;
    height: 0;
    position: relative;
    border-radius: 16px;
  }
</style>
